<div class="publish-flow-beta">
  <div
    class="modal-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="start center"
  >
    <button
      class="icon-back mr-3 d-none d-medium"
      matPreffix
      mat-icon-button
      aria-label="Back"
      mat-dialog-close
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <h2>{{ "flows.modal.confirm_edit.edit" | translate: { flow: model.flow_id } }}</h2>
    <div class="close" mat-dialog-close>
      <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
    </div>
  </div>
  <div class="modal-content mob-fixed-button">
    <div class="text-content" fxLayout="column" fxLayoutAlign="start center">
      <div class="mb-4" fxLayout="row" fxLayoutAlign="center center">
        <mat-icon svgIcon="icon_flows" class="ic-36 ic-svg-3"></mat-icon>
      </div>
      <p class="fs-18">{{ "flows.modal.confirm_edit.title" | translate }}</p>
      <span class="fs-14 fc-6">
        {{ "flows.modal.confirm_edit.subtitle" | translate }}
      </span>
    </div>
  </div>
  <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h-medium">
      <a class="close" (click)="close()">{{
        "modal-alert.cancel" | translate
      }}</a>
    </div>

    <button mat-flat-button color="primary" (click)="confirmEdit()">
      {{ "flows.modal.confirm_edit.proceed" | translate }}
    </button>
  </div>
</div>
